// extracted by mini-css-extract-plugin
module.exports = {"popover_body":"toolbar_popover_body__qHqb_"};